module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "shift_numbers.0b8cdeb3.svg";